
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UserLevelBadge } from "@/components/ui/user-level-badge";

const EngagementDefinitions = () => {
  return (
    <Card className="bg-card border-border">
      <CardHeader>
        <CardTitle className="text-card-foreground">User Level Definitions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-4">
            <div className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
              <UserLevelBadge level="Saver" size="md" />
              <div>
                <h4 className="font-medium text-foreground">Saver (Level 1)</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Has saved content in the last 7 days but minimal organization or discovery activity.
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Requirements: 1+ saves
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
              <UserLevelBadge level="Organizer" size="md" />
              <div>
                <h4 className="font-medium text-foreground">Organizer (Level 2)</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Actively saves content AND organizes it using collections, tags, or boards.
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Requirements: 1+ saves AND 1+ organization actions
                </p>
              </div>
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
              <UserLevelBadge level="Discoverer" size="md" />
              <div>
                <h4 className="font-medium text-foreground">Discoverer (Level 3)</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Saves, organizes, curates content, AND actively discovers content through search and navigation.
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Requirements: 1+ saves AND 1+ organization AND 1+ curation AND 12+ discovery
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
              <UserLevelBadge level="Curator" size="md" />
              <div>
                <h4 className="font-medium text-foreground">Curator (Level 4)</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Power user with high activity across all areas - the platform's most engaged users.
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Requirements: 6+ saves AND 3+ organization AND 3+ curation AND 20+ discovery
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <h4 className="font-medium text-blue-800 dark:text-blue-200 mb-2">Level Calculation</h4>
          <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1">
            <li>• Levels are calculated based on activity in the <strong>last 7 days</strong></li>
            <li>• Each user can only be at <strong>one level</strong> at a time</li>
            <li>• Levels update in real-time as users perform actions</li>
            <li>• Activity categories: Content Saving, Organization (collections/tags/boards), Curation (content editing/notes), Discovery (search/navigation)</li>
          </ul>
        </div>

        <div className="mt-6 p-4 bg-yellow-50 dark:bg-yellow-950/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
          <h4 className="font-medium text-yellow-800 dark:text-yellow-200 mb-2">Curation Activity Status</h4>
          <p className="text-sm text-yellow-700 dark:text-yellow-300">
            <strong>Note:</strong> Curation activities (content editing, note-taking) are currently being validated and may need troubleshooting to ensure proper tracking. 
            Check the Analytics Debug Panel for actual curation event counts.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default EngagementDefinitions;
